import { getFileCollectionTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { icons } from '@/assets/icons'

export async function buildFileCollection(taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getFileCollectionTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching file collection task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.displayName,
    subtitle: `Please provide your ${task.displayName} data.`,
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/file-collection/file/' + task.taskId, 
    createdDate: new Date(task.createdDate),
    icon: icons.document1
    }
    

  return card 
}

